import React from 'react';

import { Breadcrumbs, styled, Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';
import HeaderLayout from 'ui/HeaderLayout/HeaderLayout';

type SupportHeaderProps = { bind: string | undefined };

const StyLink = styled(Link, {
    name: 'StyLink',
})({
    color: 'inherit',
    textDecoration: 'none',
});

const SupportBreadcrumb = ({ bind }: SupportHeaderProps) => {
    const { t } = useTranslation();
    const isClientSupport = !!bind;
    return (
        <Breadcrumbs separator={<ChevronRightIcon />} aria-label="breadcrumb">
            <StyLink to="/support">
                <Tooltip
                    title={t('support.title')}
                    placement="top"
                    key="button-element"
                >
                    <Typography
                        variant="h4"
                        color={isClientSupport ? '#899FB1' : 'primary'}
                    >
                        {t('support.title')}
                    </Typography>
                </Tooltip>
            </StyLink>

            {isClientSupport && (
                <Typography variant="h4" color="primary">
                    {bind}
                </Typography>
            )}
        </Breadcrumbs>
    );
};

const SupportHeader = ({ bind }: SupportHeaderProps) => (
    <HeaderLayout title={<SupportBreadcrumb bind={bind} />} shadow={!bind} />
);

export default React.memo(SupportHeader);
